<section>
  <app-filterable-list
    id="ai-prompt-list"
    [title]="'Kyloe AI Assist prompts'"
    [placeholder]="'Search prompts...'"
    [items]="promptList"
    (itemInsertedEvent)="onFieldInserted($event)"
  >
  </app-filterable-list>
</section>
